import { matchRoutes } from "react-router";
import { routes } from "@/routes";

function leaves(node: unknown): string[] {
  if (typeof node === "string") {
    return [node];
  }
  return Object.values(node as Record<string, unknown>).flatMap(leaves);
}

const ROUTE_OBJECTS = leaves(routes).map((path) => ({ path }));

export function resolveRoutePattern(pathname: string): string {
  const matches = matchRoutes(ROUTE_OBJECTS, pathname);
  return matches?.at(-1)?.route.path ?? "*";
}
